import React, { useContext, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom";
import WheelSizeContext from "../contexts/WheelSizeContext";
import WindowContext from "../contexts/WindowContext";
import UserContext from "../contexts/UserContext";
import LifeAreasContext from "../contexts/LifeAreasContext";

import Wheel from "../components/wheel/Wheel";
import Container from "../hoc/container/Container";
import Area from "../components/area/Area";
import ProgressBar from "../components/progressBar/ProgressBar";

import arrowLeftIcon from "../assets/icons/arrow-left.svg";
import arrowRightIcon from "../assets/icons/arrow-right.svg";
import checkIcon from "../assets/icons/check.svg";
import style from "./Personal.module.css";
import { setDataInLocalStorage } from "../utils/storage";

const personalIntro = [
  <p>
    <strong>This is your personal life wheel.</strong>
    <br />
    Each segment represents an area of life that matters to you.
  </p>,
  <p>
    As you improve your score your photo becomes clearer.
    <br />
    <strong>This symbolises you fulfilling your potential.</strong>
  </p>,
  <p>
    Each area can have it's own vision and a system for making it happen.
    <br />
    <strong>You can tap on an area to enter it.</strong>
  </p>,
];

const Personal = () => {
  const windowDimensions = useContext(WindowContext);
  const wheelSize = useContext(WheelSizeContext);
  // User life areas
  const { lifeAreas, dispatchLifeAreas } = useContext(LifeAreasContext);
  // User profile
  const { state: userState, dispatch: dispatchUser } = useContext(UserContext);
  // Introduction
  const [introIndex, setIntroIndex] = useState(0);
  const introProgressPercent = (introIndex / personalIntro.length) * 100;

  // let match = useRouteMatch();
  let history = useHistory();

  // Introduction
  const completeIntro = useCallback(() => {
    setTimeout(() => {
      dispatchUser({ type: "SET_SEEN_PERSONAL_INTRO" });
    }, 500);
  }, [dispatchUser]);

  const navigateIntro = useCallback(
    (goBack: boolean) => {
      let newIndex: number;
      if (!goBack) {
        newIndex = introIndex + 1;
        if (newIndex === personalIntro.length) {
          completeIntro();
          setIntroIndex(newIndex);
        } else {
          setIntroIndex(newIndex);
        }
      } else {
        newIndex = introIndex - 1 < 0 ? 0 : introIndex - 1;
        setIntroIndex(newIndex);
      }
    },
    [introIndex, completeIntro]
  );

  // Navigation
  const goToArea = useCallback(
    (key) => {
      if (!userState.seenPersonalIntro) return;
      const url = `/personal/${key}`;
      history.push(url);
    },
    [userState.seenPersonalIntro, history]
  );

  return (
    <div className={style.container}>
      <Switch>
        <Route path="/personal/:areaKey">
          <Area />
        </Route>
        <Route path="/personal/" exact={true}>
          <Wheel
            profilePic={userState.pic}
            animateToMax={introIndex === 1}
            disabled={!userState.seenPersonalIntro}
            goToArea={goToArea}
          />
        </Route>
      </Switch>

      <section className={style.infoContainer}>
        {/* Personal Section Introduction */}
        {!userState.seenPersonalIntro ? (
          <div className={style.intro}>
            <ProgressBar percent={introProgressPercent} />
            {/* TODO: Update Container to differentiate normal and large on mobile devices */}
            <Container large={true} containerClass={style.introContainer}>
              <img
                role="button"
                onClick={() => navigateIntro(true)}
                src={arrowLeftIcon}
                alt="Back"
                style={{ opacity: introIndex === 0 ? 0 : 1 }}
              />
              <div className={style.introContent}>
                {personalIntro[introIndex]}
              </div>
              <img
                role="button"
                onClick={() => navigateIntro(false)}
                src={
                  introIndex >= personalIntro.length - 1
                    ? checkIcon
                    : arrowRightIcon
                }
                alt="Next"
              />
            </Container>
          </div>
        ) : null}
      </section>
    </div>
  );
};

export default Personal;
